module.exports = __webpack_public_path__ + "static/media/expressb.ed16db23.png";